/* tslint:disable */

/**
 */
export class MeshParamDefSave {
    dim1?: number;
    dim2?: number;
    dim3?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/mesh-param-def-save.ts